import React from 'react';

import { EchoNavigate, EchoSlot, useEcho } from '@betterment/js-runtime';
import { useLoaderData } from 'react-router-dom';

import { SettingsLayout, SettingsTab } from './SettingsLayout';

import { FullPageLoader } from '../FullPageLoader';

export const SettingsEchoRoute: React.FC<{ activeTab: SettingsTab }> = ({ activeTab }) => {
  const { echo, onSubmit } = useEcho(useLoaderData());

  if (echo.type === 'navigation') {
    return <EchoNavigate echo={echo} fallback={<FullPageLoader />} />;
  }

  return (
    <SettingsLayout activeTab={activeTab}>
      <EchoSlot slot={echo.slots.main!} onSubmit={onSubmit} />
    </SettingsLayout>
  );
};
